import { render, staticRenderFns } from "./InfrastructureGroupDialog.vue?vue&type=template&id=51f0fd4f"
import script from "./InfrastructureGroupDialog.vue?vue&type=script&lang=ts"
export * from "./InfrastructureGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports